import script from "./TutorialPopup.vue?vue&type=script&setup=true&lang=js"
export * from "./TutorialPopup.vue?vue&type=script&setup=true&lang=js"

import "./TutorialPopup.vue?vue&type=style&index=0&id=fb1774ee&lang=scss"

const __exports__ = script;

export default __exports__